module.exports = __webpack_public_path__ + "static/img/yt1.441ff62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/yt1.jpg
// module id = k49b
// module chunks = 5